<template>
  <div class="resource-list">
    <div class="resource-item" v-for="(item, idx) in resources" :key="idx"  @click="preview(item)">
      <div class="resource-icon-box-dashed">
        <img :src="iconList[item.fileType ? item.fileType-1:3]" class="resource-icon" />
      </div>
      <div class="resource-content">
        <div class="resource-title ellipsis">{{ item.fileName }}</div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="340px" :show-close="true" center>
      <template v-if="previewItem">
        <ImagePreview v-if="previewItem.fileType==2" :src="`${baseUrl}${previewItem.fileUrl}`" width="300px" height="180px" />
        <video v-else-if="previewItem.fileType==1" :src="`${baseUrl}${previewItem.fileUrl}`" controls style="width:300px;height:180px;border-radius:8px;background:#000;" />
        <audio v-else-if="previewItem.fileType==3" :src="`${baseUrl}${previewItem.fileUrl}`" controls style="width:100%;margin-top:30px;" />
        
        <button v-else class="download-btn"  @click="getCurFileUrl">{{ previewItem.fileUrl.includes(".html") ? "复制打开外链":"复制下载文件"}}</button>
      </template>
      <el-button v-if="isearnCredit && previewItem && previewItem.paperDTOList.length > 0 && previewItem.isStudy == 0 && isStudents" class="start-test-btn" type="primary" @click="earnCreditsFun( previewItem )">开始测试</el-button>
      <!-- <el-button v-if="isearnCredit && previewItem && previewItem.paperDTOList.length > 0 && (!isStudents || (previewItem.isStudy == 1 && isStudents))" class="start-test-btn" type="primary" @click="viewEarnCreditsFun( previewItem )">查看</el-button> -->
    </el-dialog>
  </div>
</template>

<script>
import { judgeClient, isWeChatBrowser, closeIos, closeAndroid } from '@/utils/index.js';
import ImagePreview from './ImagePreview/index.vue';
import { earnCredits } from "@/api/teach/courseList";
export default {
  name: 'ResourceList',
  components: { ImagePreview },
  props: ["isearnCredit","resources","isStudents"],
  data() {
    return {
      
      dialogVisible: false,
      previewItem: null,
      baseUrl:"",
      url:null,
      iconList: [
        require('@/assets/icons/video.png'),
        require('@/assets/icons/image.png'),
        require('@/assets/icons/audio.png'),
        require('@/assets/icons/word.png'),
      ],
      isStudy: "",
    };
  },
  created(){
    this.baseUrl = this.imgUrl;
    // this.baseUrl = 'https://192.168.3.126/file/';
  },
  methods:{
    viewEarnCreditsFun(item) {
      this.isStudy = item.isStudy,
      this.$router.push({
        path: "/scoreReport",
        query: {
          type: 1,
          isStudy: this.isStudy,
          isStudents: this.isStudents,
          onlineCourseId: item.onlineCourseId,
          onlineCourseResourceId: item.onlineCourseResourceId,
          paperId: item.paperDTOList[0].paperId,
        },
      });
    },
    earnCreditsFun( item ){
      this.isStudy = item.isStudy,
      this.$router.push({
        path: "/courseTopic",
        query: {
          type: 1,
          isStudy: this.isStudy,
          isStudents: this.isStudents,
          onlineCourseId: item.onlineCourseId,
          onlineCourseResourceId: item.onlineCourseResourceId,
          paperId: item.paperDTOList[0].paperId,
        },
      });
      // console.log("***********", item)
      // let par = {
      //   onlineCourseId:item.onlineCourseId,
      //   onlineCourseResourceId:item.onlineCourseResourceId

      // }
      // earnCredits( par ).then( res => {
      //   if( res.code == 200 ){
      //     this.dialogVisible = false;
      //   }

      // })
    },
      preview( row ){
        console.log('this.isearnCredit',this.isearnCredit)
        // console.log('row',row)
        // this.onlineCourseId = item.onlineCourseId;
        // this.paperDTOList = item.paperDTOList;
        // this.onlineCourseResourceId = item.onlineCourseResourceId;
        this.previewItem = row;
        console.log('this.previewItem',this.previewItem)
        if(this.isearnCredit) {
         if([1,2,3].includes(Number(row.fileType))){
           this.dialogVisible = true;
           if(this.previewItem.paperDTOList.length == 0) {
             let par = {
               onlineCourseId:row.onlineCourseId,
               onlineCourseResourceId:row.onlineCourseResourceId
             }
             earnCredits( par ).then( res => {
               if( res.code == 200 ){
                 this.dialogVisible = false;
               }
             })
           }
         }else{
           this.dialogVisible = true; 
           // if( isWeChatBrowser() ){
           //   this.dialogVisible = true; 
           // }else{
           //   if (judgeClient() == "Android") {
           //     this.opneFileAndroid( row.fileUrl );
           //   } else {
           //     this.opneFileIos( row.fileUrl );
           //   } 
 
           // }
         }
        } else {
         this.dialogVisible = true;
        }
      },
      getCurFileUrl(){
        console.log('this.isearnCredit',this.isearnCredit)
        // if(this.isearnCredit) {
        //   if(this.previewItem.paperDTOList.length == 0) {
        //     let par = {
        //       onlineCourseId:this.previewItem.onlineCourseId,
        //       onlineCourseResourceId:this.previewItem.onlineCourseResourceId
        //     }
        //     earnCredits( par ).then( res => {
        //       if( res.code == 200 ){
        //         this.dialogVisible = false;
        //       }
        //     })
        //   } else {
        //     if(this.previewItem.isStudy == 0 && this.isStudents) {
        //       this.earnCreditsFun(this.previewItem)
        //     } else if(!this.isStudents || (this.previewItem.isStudy == 1 && this.isStudents)) {
        //       this.viewEarnCreditsFun(this.previewItem)
        //     }
        //   }
        // }
       
        this.copyToClipboard( this.previewItem.fileUrl );
       
        return;
         this.opneFileIos( this.previewItem.fileUrl ); 
         return;
         if( isWeChatBrowser() ){
            this.opneFileIos( this.previewItem.fileUrl ); 
          }else{
            if (judgeClient() == "Android") {
              this.opneFileAndroid( this.previewItem.fileUrl );
            } else {
              this.opneFileIos( this.previewItem.fileUrl );
            } 
          }
      },
      opneFileAndroid( url ){
        this.$bridge.callmethod(
          "WebAction.openAppSysBrowser",
          `${this.imgUrl}/${ url }`,
          (res) => {
          }
        );
      },
      copyToClipboard( url ) {
          const pdfUrl = url.includes(".html") ? url.includes(".html") : `${ this.imgUrl }${ url}`;
          const input = document.createElement("input");
          input.value = pdfUrl;
          document.body.appendChild(input);
          input.select();
          
          try {
              // 现代浏览器（需 HTTPS 环境）
              if (navigator.clipboard) {
                  navigator.clipboard.writeText(pdfUrl)
                      .then(() =>  this.$modal.msgSuccess("复制成功，请在浏览器打开链接"))
                      .catch(() => fallbackCopy(pdfUrl));
              } 
              // 旧版浏览器兼容方案
              else if (document.execCommand("copy")) {
                  document.execCommand("copy");
                   this.$modal.msgSuccess("复制成功，请在浏览器打开链接");
              } 
              // 终极兼容方案：显示提示让用户手动复制
              else {
                  prompt("请手动复制链接", pdfUrl);
              }
          } catch (err) {
              prompt("请手动复制链接", pdfUrl);
          } finally {
              document.body.removeChild(input);
          }
      },
      opneFileIos( url ){
        alert(`${ this.imgUrl }${ url}`);
        
        
        if( url.includes(".html") ){
        }else{
        }
      },
  }
}
</script>

<style scoped>
.resource-list {
  margin-bottom: 8px;
}
.download-btn {
  margin:0 auto;
  border-radius: 22px;
  padding: 8px 28px;
  font-size: 15px;
  background: #fff;
  color: #256bfa;
  border: 1.5px solid #e3edfa;
  box-shadow: 0 2px 8px 0 rgba(37,107,250,0.04);
  outline: none;
  cursor: pointer;
  transition: box-shadow 0.2s;
  &:active {
    box-shadow: 0 1px 4px 0 rgba(37,107,250,0.10);
  }
}
.resource-item {
  display: flex;
  align-items: center;
  padding: 10px 0 10px 0;
  border-bottom: 1px solid #f0f0f0;
  min-height: 56px;
}
.resource-item:last-child {
  border-bottom: none;
}
.resource-icon-box-dashed {
  width: 42px;
  height: 42px;
  border: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  background: #fff;
}
.resource-icon {
  width: 42px;
  height: 42px;
  display: block;
}
.resource-content {
  flex: 1;
  min-width: 0;
}
.resource-title {
  font-size: 15px;
  color: #222;
  line-height: 1.4;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* 让 el-dialog 内容区域背景透明 */
::v-deep .el-dialog__body {
  background: transparent !important;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 让 el-dialog 整体背景透明（含头部和底部） */
::v-deep .el-dialog {
  background: transparent !important;
  box-shadow: none !important;
  border-radius: 0 !important;
}

/* 让关闭按钮 X 变成白色 */
::v-deep .el-dialog__close {
  color: #fff !important;
}

.start-test-btn {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 40px;
  z-index: 2000; /* 保证在弹窗等元素之上 */
  width: 200px;
  height: 48px;
  font-size: 18px;
  border-radius: 24px;
}
</style>
